import React, { createContext, useContext, useReducer } from 'react';

const CampaignContext = createContext();

const initialState = {
    activeStep: 0,
    title: '',
    audience: {
        includeTags: [],
        excludeTags: [],
        matchingUsers: []
    },
    template: {
        id: null,
        name: '',
        body: '',
        header: { type: 'TEXT', text: '', url: '' },
        footer: '',
        variables: [] // [{ index: 1, mode: 'static', value: '', dynamic_key: '' }]
    },
    schedule: {
        type: 'Immediate', // 'Immediate' or 'Custom'
        date: new Date()
    },
    loading: false,
    error: null
};

function campaignReducer(state, action) {
    switch (action.type) {
        case 'SET_STEP':
            return { ...state, activeStep: action.payload };
        case 'UPDATE_TITLE':
            return { ...state, title: action.payload };
        case 'UPDATE_AUDIENCE':
            return { ...state, audience: { ...state.audience, ...action.payload } };
        case 'UPDATE_TEMPLATE':
            return { ...state, template: { ...state.template, ...action.payload } };
        case 'UPDATE_SCHEDULE':
            return { ...state, schedule: { ...state.schedule, ...action.payload } };
        case 'SET_LOADING':
            return { ...state, loading: action.payload };
        case 'SET_ERROR':
            return { ...state, error: action.payload };
        case 'RESET':
            return initialState;
        default:
            return state;
    }
}

export const CampaignProvider = ({ children }) => {
    const [state, dispatch] = useReducer(campaignReducer, initialState);

    return (
        <CampaignContext.Provider value={{ state, dispatch }}>
            {children}
        </CampaignContext.Provider>
    );
};

export const useCampaign = () => {
    const context = useContext(CampaignContext);
    if (!context) {
        throw new Error('useCampaign must be used within a CampaignProvider');
    }
    return context;
};
